export const writeTax = (value: string | number, label: string | null = null) =>
  `${label ? label + ": " : ""}${value ?? 0}%`;
